import { render, staticRenderFns } from "./mainRegionsAsSlider.vue?vue&type=template&id=b01dca18&scoped=true&"
import script from "./mainRegionsAsSlider.vue?vue&type=script&lang=js&"
export * from "./mainRegionsAsSlider.vue?vue&type=script&lang=js&"
import style0 from "./mainRegionsAsSlider.vue?vue&type=style&index=0&id=b01dca18&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01dca18",
  null
  
)

export default component.exports